import React, { useEffect, useState } from "react";
import Layout from "../../components/Layout/Layout";
import AdminMenu from "../../components/Layout/AdminMenu";
import axios from "axios";
import toast from "react-hot-toast";
import { Link } from "react-router-dom";

const Products = () => {
  const [products, setProduct] = useState([]);
  console.log(products);

  //gete all product

  const getAllProductList = async (e) => {
    try {
      const { data } = await axios.get(`/api/v1/product/getProducts`);
      if (data?.success) {
        setProduct(data?.product);
      }
    } catch (error) {
      console.log(error);
      toast.error("Unable to fetch products");
    }
  };

  useEffect(() => {
    getAllProductList();
  }, []);
  return (
    <Layout title={"Products 3Sixteen Clothing"}>
      <div className="container-fluid m-3 p-3">
        <div className="row mt-4">
          <div className="col-md-3">
            <AdminMenu />
          </div>
          <div className="col-md-9">
            <h2 className="text-center"> All Product List</h2>
            <div className="d-flex flex-wrap  justify-content">
              {/* <table className="table table-bordered">
            <thead>
                <tr>
                <th scope="col">S.N</th>
                <th scope="col">Name</th>
                <th scope="col">Category</th>
                <th scope="col">Description</th>
                <th scope="col">Photo</th>
                <th scope="col">Price</th>
                <th scope="col">Quantity</th>
                <th scope="col">Shipping</th>
                <th scope="col">Action</th>
                
                </tr>
            </thead>
            <tbody>
               {
                products?.map((item,index)=>(
                    <tr key={item._id} >
                        <td>{index+1}</td>
                        <td>{item.name}</td>
                        <td>{item.category.name}</td>
                        <td>{item.description}</td>
                        <td>{
                            <img src={`${process.env.React_APP_API}/api/v1/product/product-photo/${item._id}`}
                            height={'100px'}
                            
                            />
                            }
                            
                            </td>
                        <td>{item.price}</td>
                        <td>{item.quantity}</td>
                        <td>{item.shipping ? 'Yes' : 'No'}</td>


                        <td></td>
                    </tr>
                )

                )
               }
            </tbody>
            </table> */}

              {products?.map((item) => (
                <Link
                  key={item._id}
                  to={`/dashboard/admin/SingleProduct/${item.slug}`}
                  className="Product-Link"
                >
                  <div className="card m-2" style={{ width: "15rem" }}>
                    <img
                      src={`/api/v1/product/product-photo/${item._id}`}
                      className="card-img-top"
                      alt={item.name}
                    />

                    <div className="card-body">
                      <h5 className="card-title">{item.name}</h5>
                      <p className="card-text">{item.description}</p>
                    </div>
                  </div>
                </Link>
              ))}
            </div>
          </div>
        </div>
      </div>
    </Layout>
  );
};

export default Products;
